// extracted by mini-css-extract-plugin
var _1 = "#e74c3c";
var _2 = "#17a2b8";
var _3 = "night";
var _4 = "#3498db";
var _5 = "#5f707c";
var _6 = "#64bc0c";
var _7 = "$warning";
export { _1 as "danger", _2 as "info", _3 as "night", _4 as "primary", _5 as "secondary", _6 as "success", _7 as "warning" }
